import axios from "axios";
import { NETWORK, SEARCH_API_DOMAIN } from "../common/Const";
import { getNetwork } from "../common/Utils";
import { IRankKeywordConfig, IResItem } from "../interface/IRankKeyword";

class RankKeywordStore {
  #config = {} as IRankKeywordConfig;
  #network: typeof NETWORK[keyof typeof NETWORK];

  constructor(config: IRankKeywordConfig) {
    this.#config = config;
    this.#network = getNetwork();
  }

  private getApiUrl() {
    return SEARCH_API_DOMAIN[this.#network]?.replace(/\/$/, '');
  }

  private async getData() {
    const { service } = this.#config || {};
    const apiUrl = this.getApiUrl();
    const DEFAULT_SIZE = 10;

    return await axios({
      method: 'get',
      withCredentials: true,
      url: `${apiUrl}/${service}/search/v2/all/rank-keyword?size=${DEFAULT_SIZE}`
    });
  }

  private setData(data: IResItem[]) {
    const list = Array.isArray(data) && data?.length > 0 ? data?.map(item => {
      const { keyword = '', type = 'new', diff = 0 } = item || {};
      const strType = type === '-' ? 'same' : type;
      const absDiff = `${Math.abs(diff)}`;
      return [keyword, strType, absDiff];
    }) : [];
    return { list };
  }

  async getList() {
    try {
      if(!this.#config?.service) {
        throw new Error('인기 검색어를 조회할 IP 서비스명이 존재하지 않습니다.');
      }

      const { data } = await this.getData();

      return this.setData(data?.list);
    } catch(error) {
      console.error(error);
      return [];
    }
  }
}

export default RankKeywordStore;